// src/features/blog/regular-articles/components/BlogSlider.tsx

'use client'; // This is our interactive island

import { Swiper, SwiperSlide } from 'swiper/react';
import BlogCard from './BlogCard';
import 'swiper/css';

// Define the type for a single blog post for type safety
interface Post {
  id: string | number;
  // Add other properties from your blog post object
}

interface SliderProps {
  posts: Post[];
}

export const BlogSlider: React.FC<SliderProps> = ({ posts }) => {
  return (
    <Swiper
      spaceBetween={12}
      slidesPerView={3} // Start with the desktop view
      breakpoints={{
        320: { slidesPerView: 1.2 },
        576: { slidesPerView: 1.5 },
        768: { slidesPerView: 2 },
        992: { slidesPerView: 3, spaceBetween: 24 },
        1200: { slidesPerView: 3 },
      }}
    >
      {posts.map((item) => (
        // Use a unique key from your data, like item.id or item.slug
        <SwiperSlide key={item.id}>
          <BlogCard item={item} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
